
/* Blue rings (Oct 6, client request): Peppermint, Immunity and Create It also come as blue rings (separate Shopify
   products, same "Subscribe & save" selling-plan group, standard $7.99 / $15.99 / $21.99, no 10-pack). The ring page
   gets a "ring color: clear / blue" picker for those three scents; blue adds the blue variant, shows the blue photo,
   and the old blue product URLs land with blue preselected (before this they silently added the clear ring).
   Cart names carry a " (blue)" suffix: esResolve maps them to the blue variant, and esSingles' "ring single$" match
   leaves blue singles out of the clear "Pick your mix" packs. */
(function(){
  var BLUE={
    'peppermint':{img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/products/Essence-bluering-peppermint.png?v=1646104428',
      v:{'single':48939101815003,'3-pack':48939101847771,'5-pack':48939101880539},h:'peppermint-scent-blue'},
    'immunity':{img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/products/Essence-bluering-immunity.png?v=1646189744',
      v:{'single':48939103158491,'3-pack':48939103191259,'5-pack':48939103224027},h:'immunity-blend-blue'},
    'create it':{img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/12_1853c39f-45fd-42da-8798-787f0941c589.png?v=1714738400',
      v:{'single':48939101028571,'3-pack':48939101061339,'5-pack':48939101094107},h:'create-it-blue-use-your-favorite-oils-or-blends'}
  };
  var PRICE={'single':7.99,'3-pack':15.99,'5-pack':21.99};
  function boot(){
    if(typeof window.renderPdp!=='function'||typeof window.esResolve!=='function'||!window.pdp||!window.SCENTS)return;
    var view=document.getElementById('view-pdp'),shelf=document.getElementById('selShelf');
    if(!view||!shelf)return;
    function cur(){var s=SCENTS[pdp.scent];return s?BLUE[esScent(s.n)]:null}
    function isBlue(){return !!(pdp.blue&&cur())}

    /* cart name "<scent> ring <size>[ (subscribed)] (blue)" -> the blue variant, plan kept */
    var origResolve=window.esResolve;
    window.esResolve=function(name){
      var n=esNorm(name);
      if(!/ \(blue\)$/.test(n))return origResolve.apply(this,arguments);
      var base=n.replace(/ \(blue\)$/,''),r=origResolve(base);
      var m=base.replace(/ \(subscribed\)$/,'').match(/^(.+?) ring (single|3-pack|5-pack)$/);
      var b=m&&BLUE[esScent(m[1])];
      if(!r||!b||!b.v[m[2]])return null;
      return {id:b.v[m[2]],plan:r.plan,props:r.props};
    };

    /* prices: blue is the standard ladder (clear immunity has its own lower ladder) */
    var origRingPrice=window.esRingPrice;
    window.esRingPrice=function(n,fmt){
      if(isBlue()&&esScent(n)===esScent(SCENTS[pdp.scent].n)&&PRICE[fmt])return PRICE[fmt];
      return origRingPrice.apply(this,arguments);
    };

    /* picker, under the scent shelf */
    var g=document.createElement('div');g.className='opt-group';g.id='ringColorGroup';
    g.innerHTML='<div class="opt-label">ring color &middot; <span id="ringColorName" style="color:var(--ink);letter-spacing:0"></span></div><div class="shelf" id="ringColorShelf"></div>';
    shelf.closest('.opt-group').insertAdjacentElement('afterend',g);
    var cs=g.querySelector('#ringColorShelf');
    [['clear','clear','#F1EEE8'],['blue','blue','#3D7FC4']].forEach(function(c){
      var b=document.createElement('button');b.className='chip2';b.setAttribute('data-ring-color',c[0]);
      b.innerHTML='<span class="d" style="background:'+c[2]+';border:1px solid var(--line)"></span>'+c[1];
      b.onclick=function(){pdp.blue=(c[0]==='blue');window.renderPdp()};
      cs.appendChild(b);
    });

    var origRender=window.renderPdp;
    window.renderPdp=function(){
      var b=cur();
      if(b&&pdp.blue&&pdp.pack===3)pdp.pack=2;           /* no blue 10-pack */
      var r=origRender.apply(this,arguments);
      g.style.display=b?'':'none';
      var blue=isBlue();
      cs.querySelectorAll('button').forEach(function(x){
        var sel=(x.getAttribute('data-ring-color')==='blue')===blue;
        x.setAttribute('aria-current',sel?'true':'false');
        x.style.background=sel?'var(--ink)':'var(--white)';x.style.color=sel?'var(--cream)':'var(--ink)';x.style.borderColor=sel?'var(--ink)':'var(--line)';
      });
      var nm=document.getElementById('ringColorName');if(nm)nm.textContent=blue?'blue':'clear';
      var ten=document.querySelector('#packRow .pack[data-pack="3"]');if(ten&&blue)ten.style.display='none';
      if(blue){
        var gi=document.getElementById('galleryImg'),mv=document.getElementById('galleryMv'),th=document.getElementById('galThumbs');
        if(mv)mv.style.display='none';
        if(gi){gi.style.display='';gi.src=b.img;gi.alt=SCENTS[pdp.scent].n+' blue scent ring';gi.style.width='82%'}
        if(th)th.hidden=true;
      }
      return r;
    };

    window.pdpAddToCart=function(){
      var s=SCENTS[pdp.scent];
      quickAdd(s.n+' ring '+PACKS[pdp.pack].label+(pdp.deliv==='sub'?' (subscribed)':'')+(isBlue()?' (blue)':''),pdpPrice());
      cartDrawer(true);
    };

    /* old blue product URLs (Google Shopping, emails, bookmarks) land on blue */
    var path=location.pathname.replace(/\/$/,''),landKey=null;
    Object.keys(BLUE).forEach(function(k){if(path==='/products/'+BLUE[k].h)landKey=k});
    if(landKey)pdp.blue=true;

    /* a different scent starts on clear, except the router's first pick of the blue landing scent */
    var origPick=window.pickScent;
    window.pickScent=function(i){
      var s=SCENTS[i];
      if(landKey&&s&&esScent(s.n)===landKey){pdp.blue=true;landKey=null}
      else if(i!==pdp.scent)pdp.blue=false;
      return origPick.apply(this,arguments);
    };
    try{window.renderPdp()}catch(e){}
    setTimeout(function(){landKey=null},5000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
